import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { StatsData } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getStats(axios: AxiosInstance): Promise<StatsData> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/task/stats`);

  return data;
}

export default function useStatsQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['Stats'],
    queryFn: () => getStats(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['open-tasks'] as const satisfies QueryKey;
}
useStatsQuery.getKey = getKey;
